import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    "Vendor Name",
    "Description",
    "Status",
    "Action"
  ];
  
  export const TABLE_DATA = [
    { id: 1, vender_type_name: "Tier 1 Suppliers", vender_type_desc:"lorem ipsum",status: "Active", actions: "Edit/Delete" },
    { id: 2, vender_type_name: "Tier 2 Suppliers", vender_type_desc:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, navender_type_nameme: "Component Suppliers", vender_type_desc:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "Vendor Name": "vendor_type_name",
    "Description":"vendor_type_desc",    
    "Status": "status",
    "Action": [
        { type: "edit", icon: editIcon, label: "Edit" },
        
      ]
  };